// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  WebhookEventCause,
  WebhookEventCauseFromJSON,
  WebhookEventCauseToJSON,
  WebhookEventData,
  WebhookEventDataFromJSON,
  WebhookEventDataToJSON,
  WebhookEventType,
  WebhookEventTypeFromJSON,
  WebhookEventTypeToJSON,
  WebhookResourceType,
  WebhookResourceTypeFromJSON,
  WebhookResourceTypeToJSON,
} from "./";

/**
 * Immutable event delivered to the receiver. Business events require resource_type/resource_id/resource_version. A synthetic webhook.test omits real resource identifiers. Status events include previous_data and data with native numeric plan/run statuses or string execution statuses.
 * @export
 * @interface WebhookEventPayload
 */
export interface WebhookEventPayload {
  /**
   *
   * @type {string}
   * @memberof WebhookEventPayload
   */
  schemaVersion: WebhookEventPayloadSchemaVersionEnum;
  /**
   *
   * @type {string}
   * @memberof WebhookEventPayload
   */
  eventId: string;
  /**
   *
   * @type {WebhookEventType}
   * @memberof WebhookEventPayload
   */
  eventType: WebhookEventType;
  /**
   * UTC event time, unchanged on retry.
   * @type {string}
   * @memberof WebhookEventPayload
   */
  occurredAt: string;
  /**
   *
   * @type {number}
   * @memberof WebhookEventPayload
   */
  project: number;
  /**
   *
   * @type {WebhookResourceType}
   * @memberof WebhookEventPayload
   */
  resourceType?: WebhookResourceType;
  /**
   *
   * @type {number}
   * @memberof WebhookEventPayload
   */
  resourceId?: number;
  /**
   * Monotonic version for this resource; not a global sequence.
   * @type {number}
   * @memberof WebhookEventPayload
   */
  resourceVersion?: number;
  /**
   *
   * @type {string}
   * @memberof WebhookEventPayload
   */
  correlationId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof WebhookEventPayload
   */
  changedFields: Array<string>;
  /**
   *
   * @type {WebhookEventCause}
   * @memberof WebhookEventPayload
   */
  cause?: WebhookEventCause;
  /**
   *
   * @type {WebhookEventData}
   * @memberof WebhookEventPayload
   */
  previousData?: WebhookEventData;
  /**
   *
   * @type {WebhookEventData}
   * @memberof WebhookEventPayload
   */
  data: WebhookEventData;
}

export function WebhookEventPayloadFromJSON(json: any): WebhookEventPayload {
  return {
    schemaVersion: json["schema_version"],
    eventId: json["event_id"],
    eventType: WebhookEventTypeFromJSON(json["event_type"]),
    occurredAt: json["occurred_at"],
    project: json["project"],
    resourceType: !exists(json, "resource_type")
      ? undefined
      : WebhookResourceTypeFromJSON(json["resource_type"]),
    resourceId: !exists(json, "resource_id") ? undefined : json["resource_id"],
    resourceVersion: !exists(json, "resource_version")
      ? undefined
      : json["resource_version"],
    correlationId: json["correlation_id"],
    changedFields: json["changed_fields"],
    cause: !exists(json, "cause")
      ? undefined
      : WebhookEventCauseFromJSON(json["cause"]),
    previousData: !exists(json, "previous_data")
      ? undefined
      : WebhookEventDataFromJSON(json["previous_data"]),
    data: WebhookEventDataFromJSON(json["data"]),
  };
}

export function WebhookEventPayloadToJSON(value?: WebhookEventPayload): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    schema_version: value.schemaVersion,
    event_id: value.eventId,
    event_type: WebhookEventTypeToJSON(value.eventType),
    occurred_at: value.occurredAt,
    project: value.project,
    resource_type: WebhookResourceTypeToJSON(value.resourceType),
    resource_id: value.resourceId,
    resource_version: value.resourceVersion,
    correlation_id: value.correlationId,
    changed_fields: value.changedFields,
    cause: WebhookEventCauseToJSON(value.cause),
    previous_data: WebhookEventDataToJSON(value.previousData),
    data: WebhookEventDataToJSON(value.data),
  };
}

/**
 * @export
 * @enum {string}
 */
export enum WebhookEventPayloadSchemaVersionEnum {
  _1 = "1",
}
